module.exports = __webpack_public_path__ + "static/media/PA-Icon-Vogel-pos.b62d0cd6.svg";